import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";

export default function BrandMarquee({ items, testId = "brand-marquee" }) {
  return (
    <section className="border-y border-dejure-silver/30 bg-white py-8" data-testid={testId}>
      <Marquee speed={30} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif text-4xl md:text-6xl text-dejure-purple px-10">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-dejure-purple" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
